import { useEffect, useState } from 'react';

const getRemainingSeconds = (targetDate: string): number => {
  const remainingMilliseconds = new Date(targetDate).getTime() - Date.now();
  if (!Number.isFinite(remainingMilliseconds)) return 0;

  // Floor intentionally reaches zero slightly early, so a positive value always represents
  // at least one full second in which the submission request can be made.
  return Math.max(0, Math.floor(remainingMilliseconds / 1000));
};

const useDetectionCountdown = (targetDate: string) => {
  const [remainingSeconds, setRemainingSeconds] = useState(() => getRemainingSeconds(targetDate));

  useEffect(() => {
    const update = () => setRemainingSeconds(getRemainingSeconds(targetDate));
    update();

    const intervalId = window.setInterval(update, 250);
    return () => window.clearInterval(intervalId);
  }, [targetDate]);

  return remainingSeconds;
};

export default useDetectionCountdown;
